import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useContractTemplatesList() {

    const toast = useToast()

    const refContractTemplateListTable = ref(null)

    const tableColumns = [
        { key: 'id', label: '編號', sortable: true },
        { key: 'name', label: '模版名稱' },
        { key: 'preview', label: '預覽', sortable: true },
        { key: 'sort_order', label: '排序', sortable: true },
        { key: 'is_active', label: '狀態', sortable: true },
        { key: 'action', label: '操作' },
    ]

    const perPage = ref(10)
    const totalRow = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(false)


    const dataMeta = computed(() => {
        const localItemsCount = refContractTemplateListTable.value ? refContractTemplateListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalRow.value,
        }
    })

    const showMessage = (title, text, icon, variant) => {
        toast({
            component: ToastificationContent,
            props: {
                title,
                text,
                icon,
                variant
            },
        })
    }

    const refetchData = () => {
        refContractTemplateListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })


    const templateList = ref(null)

    const fetchContractTemplates = (ctx, callback) => {
        

        store.dispatch('contract-template/fetchContractTemplates', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
            .then(response => {
                const { contract_templates, total } = response.data
                callback(contract_templates)
                templateList.value = contract_templates
                totalRow.value = total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching contract templates list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    return {
        fetchContractTemplates,
        tableColumns,
        perPage,
        currentPage,
        totalRow,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refContractTemplateListTable,
        showMessage,
        templateList,
        ability
    }

}